import { i18n } from '@/plugins/i18n'

export default {
  defaultObject () {
    return {
      id: null,
      name: '',
      username: '',
      email: '',
      avatar: '',
      password: 'vanguarderbpv123', // so it isnt empty
      isSuspended: false,
      wialonId: '',
      creationFrom: 'ASGARD',
      parentId: null,
      companyCode: '',
      accountId: '',
      timeZone: ''
    }
  },
  userSources () {
    return [
      {
        value: 'WIALON',
        text: i18n.t('users.sources.wialon')
      },
      {
        value: 'ASGARD',
        text: i18n.t('users.sources.vanguarder')
      }
    ]
  }
}
